module.exports = __webpack_public_path__ + "static/media/eeeae646-c964-4dbb-9269-da8dc83b40f7.2f5f262c.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/Fonts/eeeae646-c964-4dbb-9269-da8dc83b40f7.ttf
// module id = 76
// module chunks = 0